import React, { useMemo } from 'react'; // <-- Import useCallback
import { Form, Field } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { FieldArray } from 'react-final-form-arrays';
import { TextField } from 'mui-rff';
import { Grid, InputLabel, Stack, IconButton, Button } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

import FormStateToRedux from '../FormStateToRedux';

// <-- STEP 1: Move pure functions OUTSIDE the component.
// This prevents them from being recreated on every render.
const transformDataToFields = (obj) => {
  if (!obj) return [];
  return Object.entries(obj).map(([key, value]) => ({
    key,
    value: String(value),
  }));
};

export default function LobPropertiesJsonForm({
  name = 'JSONForm',
  label,
  data,
}) {
  // @TODO: implement
  // eslint-disable-next-line no-unused-vars
  const onSubmit = (values) => {};

  // eslint-disable-next-line no-unused-vars
  const validateForm = (values) => {
    const errors = {};

    // @TODO: validate form

    return errors;
  };

  // This one is already correct from our last fix
  const initialValues = useMemo(
    () => ({
      properties: transformDataToFields(data),
    }),
    [data],
  );

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={initialValues}
      validate={validateForm}
      mutators={{ ...arrayMutators }}
      keepDirtyOnReinitialize
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <FormStateToRedux form={name} />
          <Grid
            item
            xs={12}>
            <InputLabel sx={{ mb: 0, fontWeight: 'bold' }}>{label}</InputLabel>
            <FieldArray name="properties">
              {({ fields }) => (
                <Stack spacing={2}>
                  {fields.map((field, index) => {
                    const itemType = fields.value[index].type;
                    return (
                      <Stack
                        direction="row"
                        spacing={1}
                        key={field}
                        alignItems="center">
                        <Field name={`${field}.key`}>
                          {({ input, meta }) => (
                            <TextField
                              {...input}
                              label="Key"
                              margin="dense"
                              fullWidth
                              error={meta.touched && !!meta.error}
                              helperText={meta.touched && meta.error}
                            />
                          )}
                        </Field>
                        <Field name={`${field}.value`}>
                          {({ input, meta }) => (
                            <TextField
                              {...input}
                              label="Value"
                              margin="dense"
                              fullWidth
                              style={{ marginTop: '4px' }}
                              type={itemType === 'number' ? 'number' : 'text'}
                              error={meta.touched && !!meta.error}
                              helperText={
                                (meta.touched && meta.error) ||
                                (itemType === 'boolean'
                                  ? 'Enter "true" or "false"'
                                  : '')
                              }
                            />
                          )}
                        </Field>
                        <IconButton
                          color="error"
                          onClick={() => fields.remove(index)}
                          aria-label="Remove property"
                          sx={{ mt: 1 }}>
                          <DeleteIcon />
                        </IconButton>
                      </Stack>
                    );
                  })}
                  <Button
                    sx={{ color: 'primary', marginLeft: '10px' }}
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={() => fields.push({ key: '', value: '' })}>
                    Add Property
                  </Button>
                </Stack>
              )}
            </FieldArray>
          </Grid>
        </form>
      )}
    />
  );
}
